<template>
  <div>
    <div class="">
      <img src="/images/spinner-gif.gif" class="img-fluid loader-css" alt="loading" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

